export const USERROLEENUM = {
  ADMIN: 1,
  HR: 2,
  FINANCE: 3,
  MANAGER: 4,
  EMPLOYEE: 5,
  TSApprover: 6,
} as const;

export const daysDataEnum = {
  WEEKDAY: 1,
  WEEKEND: 2,
  HOLIDAY: 3,
} as const;

export const ReportStatusEnum = {
  New: 1,
  Waitingforapproval: 2,
  Approved: 3,
  Returnedforreview: 4,
  Senttoclient: 5,
  Waitingforpartialapproval: 6,
  PartiallyApproved: 7,
} as const;

export const ReportFormButtonPermissionStatusEnum = {
  user: [
    ReportStatusEnum.Approved,
    ReportStatusEnum.PartiallyApproved,
    ReportStatusEnum.Senttoclient,
    ReportStatusEnum.Waitingforapproval,
    ReportStatusEnum.Waitingforpartialapproval,
  ],
} as const;

// IPMS
export const GoalsFlagStatusEnumText: Record<string, string> = {
  DRAFT: "Saved",
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};
export const GoalsFlagStatusEnumTextCap: Record<string, string> = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export const GoalsAssessmentFlagStatusEnumTextCap: Record<string, string> = {
  NOT_STARTED: "NOT STARTED",
  READY: "READY",
  SUBMITTED: "SUBMITTED",
  SUBMIT: "SUBMITTED",
  APPROVED: "APPROVED",
  COMPLETED: "COMPLETED",
};

export const GoalsFlagStatusEnum = {
  save: 1,
  submit: 2,
  approved: 3,
  rejected: 4,
};

export const GoalsFlagListStatusEnum: Record<number, string> = {
  1: "Saved",
  2: "Added",
  3: "Approved",
  4: "Completed",
};

export const GoalsAssessmentFinalStatusSEnum: Record<string, string> = {
  SUBMITTED: "Employee Review Complete",
  APPROVED: "Manager Approved",
  COMPLETED: "HR Approved",
};

export const GoalsAssessmentFinalStatusSEnumother: Record<string, string> = {
  SUBMITTED: "Employee Review Complete",
  APPROVED: "Manager Approved",
  COMPLETED: "HR Approved",
};

export const GoalsAssessmentFinalStatusProgressbarSEnum: Record<string, string> = {
  SUBMITTED: "70%",
  APPROVED: "90%",
  COMPLETED: "100%",
};

export const GoalsAssessmentFinalStatusProgressbarSEnumOther: Record<string, string> = {
  SUBMITTED: "70%",
  APPROVED: "90%",
  COMPLETED: "100%",
};


export const GoalsAssessmentFinalwaitingStatusSEnum: Record<string, string> = {
  SUBMITTED: "Manager Approval Pending",
  APPROVED: "Waiting HR Approval",
  COMPLETED: "Completed",
};

export const GoalsAssessmentFinalStatuswaitingSEnumother: Record<string, string> = {
  SUBMITTED: "Manager Approval Pending",
  APPROVED: "Waiting HR Approval",
  COMPLETED: "Completed",
};

